<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :title="title"
    width="1300px"
    :before-close="cancel"
    class="main-content change-charge-window"
  >
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        config-module="13011111"
        :row-data="rowData"
        min-height="400px"
      />
    </div>
    <div slot="footer">
      <div v-if="defaultProperties.editMode === 'add'" style="float: left;margin-bottom: 10px">
        <el-button type="primary" size="mini" @click="add">{{ $t('CargoMsg.Cargo_add') }}</el-button>
        <el-button type="danger" size="mini" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
      </div>
      <div style="float: right;margin-bottom: 10px">
        <el-button type="primary" size="mini" @click="saveEvent">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button size="mini" @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceMultipleSelectEditor
  from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { Charge } from '@/class/model/act/Charge'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index'
import { deepClone } from '@/utils'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { getCustomerByRole, saveAdjustJob } from '@/api/booking/job'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import StrUtils from '@/utils/StrUtils'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'AddChargeDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultProperties: { type: Object, required: true }, // 弹框打开时默认传递条件
    config: { type: Object, required: true },
    inputIncludingTaxUnitPrice: { type: Number, default: 0 } // 单价是否含税
  },
  data() {
    return {
      userId: 0,
      departmentId: 0,
      selectTypeNames: TYPE_NAMES,
      privilege: {
        isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']) // 是否有应收受控费用权限
      },
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor,
          CargoAgGridCommonTextareaEditor
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: this.getChargeItemFilter(),
              tagValue: 'itemId',
              tagName: this.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                return true
              },
              filterable: true,
              staticOptions: [...this.currentViewCacheData.customerSalesCmpSet]
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.domestic_settlementAgent'),
          colId: 'settlementAgentId',
          field: 'settlementAgentId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              // selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              // methodParams: { active: true, settlementAgent: true, cmpIdx: params.data.accountId },
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                return true
              },
              filterable: true,
              staticOptions: this.getSettlementAgent(params.data.accountId)
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'invoiceTitle',
          field: 'invoiceTitle',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'invoiceTitle',
              tagName: 'invoiceTitle',
              allowCreate: true,
              staticOptions: this.getInvoiceTitleList(params.data.accountId),
              filterable: true,
              filterTagNames: ['invoiceTitle'],
              filterType: 'global'
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.internal') }, { code: true, value: this.$t('SeaExport.overseas') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 6
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              methodParams: { unit: true, seaFreight: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          },
          // editable: (params) => this.editable && !params.data.uuid,
          editable: false,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE]
            return {
              selectProps: {
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions,
                filterable: true,
                filterTagNames: ['code', 'chineseName']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount',
          field: 'excludingTaxAmount',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && !!this.inputIncludingTaxUnitPrice,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }],
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          hide: !this.inputIncludingTaxUnitPrice,
          suppressColumnsToolPanel: !this.inputIncludingTaxUnitPrice
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_contactPerson'),
          colId: 'contactPerson',
          field: 'contactPerson',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = this.currentViewCacheData.companyContactPersonMap.get(params.data.accountId)
            return {
              selectProps: {
                tagValue: 'contactPerson',
                tagName: 'contactPerson',
                staticOptions,
                filterable: true,
                filterTagNames: ['contactPerson']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: (params) => {
            const staticOptionsMbl = [...this.currentViewCacheData.mblCargoDocSet]
            const staticOptionsHbl = [...this.currentViewCacheData.hblCargoDocSet]
            const optionsMBLValue = {}
            const optionsHBLValue = {}
            if (staticOptionsMbl.length > 0) {
              optionsMBLValue.label = 'MBL No.'
              optionsMBLValue.options = staticOptionsMbl
              optionsMBLValue.filterable = true
            }
            if (staticOptionsHbl.length > 0) {
              optionsHBLValue.label = 'HBL No.'
              optionsHBLValue.options = staticOptionsHbl
              optionsHBLValue.filterable = true
            }
            return {
              isGroup: true,
              tagValue: 'chargeRelatedBLNo',
              tagName: 'chargeRelatedBLNo',
              options: [optionsMBLValue, optionsHBLValue]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...this.currentViewCacheData.containerNoAllSet]
            return {
              selectProps: {
                tagValue: 'containerNo',
                tagName: 'containerNo',
                staticOptions,
                filterable: true
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_freightCollectOrPrepaid'),
          colId: 'ppcc',
          field: 'ppcc',
          initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            const options = [...this.currentViewCacheData.paymentTermSet]
            const curOption = options.find(option => option.code === params.value)
            if (curOption) {
              return curOption.name
            }
            return ''
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...this.currentViewCacheData.paymentTermSet]
            return {
              selectProps: {
                tagValue: 'code',
                tagName: 'name',
                staticOptions,
                filterable: true,
                filterTagNames: ['name']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ],
      rowData: [],
      isAr: false,
      lob: '',
      loading: false,
      accountObjectControlMode: false,
      arSettlementUnitOptional: false,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        companyContactPersonMap: new Map(), // company对应的联系人map 缓存
        companyCmpIdxForCustomerMap: new Map(), // 结算单位
        chargeMeasureSet: new Set(), // 费用单位
        mblCargoDocSet: new Set(), // 关单号set
        hblCargoDocSet: new Set(), // 关单号set
        officeIdForDepartmentMap: new Map(),
        officeIdForClearDepartmentMap: new Map(), // 结算公司
        currencySet: new Set(),
        userAllSet: new Set(), // cache中取得全部用户集合
        containerNoAllSet: new Set(), // 全部箱号
        user4AuditorSet: new Set(), // 审核人数据集合
        paymentTermSet: new Set(),
        customerDefaultTitleMap: new Map(), // 委托单位和默认发票抬头
        customerTitlesMap: new Map(), // 委托单位和关联的发票抬头
        customerSettlementAgentMap: new Map(), // 结算对象关联的结算代理
        chargeItemSet: new Set(), // 费用项目,
        customerSalesCmpSet: new Set() // 结算对象
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    language() {
      return this.$store.getters.language === 'zh'
    },
    job() {
      return this.defaultProperties.job
    },
    title() {
      if (this.defaultProperties.editMode === 'add') {
        return this.defaultProperties.isAr ? this.$t('Message.AddCostCharge') : this.$t('Message.AddPayCharge')
      }
      if (this.defaultProperties.editMode === 'edit') {
        return this.$t('SeaExport.EditCharges')
      }
      if (this.defaultProperties.editMode === 'del') {
        return this.$t('CargoMsg.Cargo_DeleteFee')
      }
      return ''
    },
    editable() {
      return this.defaultProperties.editMode !== 'del'
    },
    officeId() {
      return this.defaultProperties.branchId || this.$store.getters.currentOfficeId
    }
  },
  created() {
    this.userId = this.$store.getters.userId
    this.departmentId = this.$store.getters.currentDeptId
    this.onShow()
  },
  mounted() {
    if (this.defaultProperties.editMode !== 'add' && this.defaultProperties.charge) {
      this.rowData = deepClone(this.defaultProperties.charge)
      return
    }
    this.$nextTick(() => {
      this.add()
    })
  },
  methods: {
    async onShow() {
      await cache.load(cacheName.CONFIG)
      this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode')) === 1
      this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      await this.loadCustomerSalesCmpSet()
      this.initCurrencySet()
      this.initChargeItemSet()
      this.initPaymentTermSet()
    },
    async add() {
      const item = new Charge().fillDefaultValue().getData()
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.officeId)
      item.localCurrency = localCurrency
      item.currency = localCurrency
      item.jobUuid = this.job.uuid
      item.businessDate = this.job.businessDate
      item.inputBy = this.userId
      item.inputDate = new Date()
      item.auditDate = new Date()
      item.inputByDep = this.departmentId
      item.branchId = this.officeId
      item.receivable = this.defaultProperties.isAr
      item.verifiedAmount = 0
      item.adjustment = false
      item.offsetState = 0
      item.chargeState = 0
      item.measure = 'NML'
      item.accountId = this.job.customerId
      if (item.settlementAgentId === 0 || item.settlementAgentId === '0') {
        item.settlementAgentId = null
      }
      const office = this.$store.getters.currentOffice
      if (office && String(office.taxRate) !== 'NaN') {
        item.taxRate = office.taxRate
      } else {
        item.taxRate = 0
      }
      item.taxRate = ChargeUtils.getTaxRateAtCreateCharge(item)
      item.unitPriceIncludeTax = this.inputIncludingTaxUnitPrice === 2
      this.rowData.push(item)
      this.gridOptions.api.refreshCells({ force: true })
    },
    // 获取结算代理
    getSettlementAgent(accountId) {
      if (!accountId || accountId <= 0) {
        return []
      }
      if (this.currentViewCacheData.customerSettlementAgentMap.has(accountId)) {
        return this.currentViewCacheData.customerSettlementAgentMap.get(accountId)
      }
      return []
    },
    remove() {
      const api = this.gridOptions.api
      const rows = api.getSelectedRows()
      api.updateRowData({ remove: rows })
      const rowData = []
      api.forEachNode(node => rowData.push(node.data))
      this.rowData = rowData
      this.gridOptions.api.refreshCells({ force: true })
    },
    async saveEvent() {
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      const result = []
      if (!await ChargeUtils.checkUnitRate(this.rowData, this)) {
        return
      }
      for (const item of this.rowData) {
        if (!this.validateCharge(item)) {
          return
        }
        // 后端有处理
        // item.serialNumber = this.refreshSerialNumber(item.isAr, this.job.charges)
        result.push(item)
      }
      this.loading = getLoading4Cxt(this)
      saveAdjustJob(result, { editMode: this.defaultProperties.editMode, location: this.location }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        this.$emit('returnCall', res.data)
        this.cancel()
      }).finally(() => {
        this.loading.close()
      })
    },
    async onCellChange(params) {
      let firstAccountId = false
      if (!params.oldValue) {
        firstAccountId = true
      }
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        firstAccountId: firstAccountId,
        originalValue: params.oldValue
      }
      await this.chargeGridItemEditEndHandler(newParams)
    },
    async chargeGridItemEditEndHandler(params) {
      const job = this.job
      const charge = params.data
      const oldInvoceTitle = charge.invoiceTitle
      await ChargeColumnUtil.changeChargeCellChangeHandler(params, job, this.currentViewCacheData, this.inputIncludingTaxUnitPrice, this.config.currencyChangeBySettlementAccount)
      // 加载开票抬头
      await this.getTitlesByCompanyId(charge)
      if (charge.invoiceTitle) {
        if (params.field === 'invoiceTitle' || charge.invoiceTitle !== oldInvoceTitle) {
          const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, this.getInvoiceTitleList(charge.accountId))
          if (!flag && charge.invoiceTitle !== oldInvoceTitle && charge.accountId > 0 && params.field === 'accountId') {
            await ChargeUtils.updateOverseaByAccountId(charge)
          }
        }
      } else if (charge.accountId > 0) {
        if (params.field === 'accountId') {
          await ChargeUtils.updateOverseaByAccountId(charge)
        }
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    getInvoiceTitleList(accountId) {
      if (this.currentViewCacheData.customerTitlesMap.get(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    },
    async getTitlesByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      if (this.currentViewCacheData.customerTitlesMap.has(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId)
      }
      // 获取数据库中维护的开票抬头
      const res = await queryTitleByCpmIdx(accountId)
      let dbTitles = res.data
      if (!dbTitles) dbTitles = []
      if (dbTitles.length > 0) {
        for (const title of dbTitles) {
          if (!title.title) continue
          title.invoiceTitle = title.title
        }
      }
      this.currentViewCacheData.customerTitlesMap.set(accountId, dbTitles)
      return this.currentViewCacheData.customerTitlesMap.get(accountId)
    },
    refreshSerialNumber(isAr, charges) {
      let number = 0
      if (!charges) return number
      for (const c of charges) {
        if (c.receivable === isAr) {
          number++
        }
      }
      return number
    },
    cancel() {
      this.$emit('close')
    },
    // 费用项目过滤
    getChargeItemFilter() {
      let filter = {}
      switch (this.job.lob) {
        case 'SE':
          filter = { seaExport: true, active: true }
          break
        case 'SI':
          filter = { seaImport: true, active: true }
          break
        case 'AE':
          filter = { airExport: true, active: true }
          break
        case 'AI':
          filter = { airImport: true, active: true }
          break
        case 'RE':
        case 'RI':
          filter = { railwayExport: true, active: true }
          break
        default:
      }
      if (this.defaultProperties.isAr) {
        if (!this.privilege.isControlled) {
          filter.controlled = false
        }
      } else {
        if (!this.privilege.isCostControlled) {
          filter.controlled = false
        }
      }
      return filter
    },
    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currentViewCacheData.currencySet = new Set(results)
      this.initCargoDocSet()
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.currentViewCacheData.chargeItemSet = new Set(results)
    },
    initPaymentTermSet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_PaymentTerm)
      this.currentViewCacheData.paymentTermSet = new Set(results)
    },
    async initCargoDocSet() {
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getCargoDoc()
      this.currentViewCacheData.mblCargoDocSet = new Set()
      this.currentViewCacheData.hblCargoDocSet = new Set()
      const j = this.job
      for (const seDoc of this.job.cargoDoc || []) {
        if (j.lob === 'SE' || j.lob === 'SI') {
          if (seDoc.docType === CargoDocConsts.MBL && j.signMBL) {
            if (!StrUtils.isEmpty(this.job.mbl)) {
              seDoc.chargeRelatedBLNo = this.job.mbl
              this.currentViewCacheData.mblCargoDocSet.add(seDoc)
            }
          } else if (seDoc.docType === CargoDocConsts.MBL2 && j.signMBL && j.typeMBL !== 1 && !seDoc.deleted) {
            if (!StrUtils.isEmpty(seDoc.mblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.mblNbr2
              this.currentViewCacheData.mblCargoDocSet.add(seDoc)
            }
          } else if ((seDoc.docType === CargoDocConsts.HBL || (seDoc.docType === CargoDocConsts.HBL2 && j.typeHBL !== 1)) && !seDoc.deleted && j.signHBL && !j.masterFlag) {
            if (!StrUtils.isEmpty(seDoc.hblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.hblNbr2
              this.currentViewCacheData.hblCargoDocSet.add(seDoc)
            }
          }
        }
      }
      this.getAllContainerNoHandler()
    },
    async loadCustomerSalesCmpSet() {
      if (this.arSettlementUnitOptional && this.defaultProperties && this.defaultProperties.isAr) {
        this.currentViewCacheData.customerSalesCmpSet = new Set(this.defaultProperties.companyFactorySigns || [this.job.customerId])
      } else {
        let results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Company)
        if (this.accountObjectControlMode && this.defaultProperties.isAr && !this.$store.getters.isAdmin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
          const customerCmpList = await getCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => res.data)
          results = results.filter(item => customerCmpList.includes(item.cmpIdx))
        }
        this.currentViewCacheData.customerSalesCmpSet = new Set(results)
      }
    },
    // 保存费用校验
    validateCharge(charge) {
      if (isNaN(charge['accountId']) || Number(charge['accountId']) <= 0) {
        this.$message.warning(this.$t('Message.SettlementPartyCannotBeNull'))
        return false
      }
      if (isNaN(charge['chargeItemId']) || Number(charge['chargeItemId']) <= 0) {
        this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
        return false
      }
      if (isNaN(charge['quantity']) || Number(charge['quantity']) === 0) {
        this.$message.warning(this.$t('Message.AmountCannotBeZero'))
        return false
      }
      if (isNaN(charge['exchangeRate']) || Number(charge['exchangeRate']) === 0) {
        this.$message.warning(this.$t('Message.ExchangeCannotBeZero2'))
        return false
      }
      if (charge['remarks'] && charge['remarks'].length > 50) {
        this.$message.warning(this.$t('Message.RemarkTheLengthCannotExceed'))
        return false
      }
      if (charge['chargeItemId']) {
        const message = ChargeUtils.checkChargeRateRange(charge)
        if (message) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
          return
        }
      }
      return true
    },
    getAllContainerNoHandler() {
      if (this.job.containers) {
        this.currentViewCacheData.containerNoAllSet = new Set()
        for (const c of this.job.containers) {
          if (c.containerNo) {
            const cData = {}
            cData['containerNo'] = c.containerNo
            this.currentViewCacheData.containerNoAllSet.add(cData)
          }
        }
      }
    }

  }
}
</script>
<style lang="scss">
  .change-charge-window {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
